import { MODAL_LIST_DATA } from '@/constants/modals';

export const state = () => ({
  modalsList: [
    // {
    //   id: MODAL_LIST_DATA.CREDIT_RATING
    // }
  ],
  disableClickToClose: false
});

export const mutations = {
  CLEAR_MODALS (state) {
    state.modalsList = [];
  },

  PUSH_MODAL (state, modal) {
    state.modalsList.push(modal);
  },

  PREPEND_MODAL (state, modal) {
    state.modalsList.unshift(modal);
  },

  REMOVE_MODAL (state, modalId) {
    state.modalsList = state.modalsList.filter(m => m.id !== modalId);
  },

  SET_DISABLE_CLICK_TO_CLOSE (state, value) {
    state.disableClickToClose = value;
  }
};

export const getters = {
  getCurrentModal (state) {
    return state.modalsList[0] || null;
  },
  getDisableClickToClose (state) {
    return state.disableClickToClose;
  }
};

export const actions = {
  async submitSignUpModal ({ commit, dispatch }, payload) {
    try {
      await this.$api('/users/subscriptions', {
        method: 'post',
        subscription: {
          ...payload,
          user_id: this.getters['user/getUserId'],
          customer_id: this.getters['user/getCustomerId']
        }
      });

      const user = this.getters['user/get'];
      if (user) {
        commit('user/set', { ...user, optin_newsletter: true }, { root: true });
      }

      dispatch('matomo/trackCTAClick', { name: 'Signed up for newsletter' }, { root: true });
      commit('REMOVE_MODAL', MODAL_LIST_DATA.NEWSLETTER_SIGNUP);
      commit('PUSH_MODAL', { id: MODAL_LIST_DATA.NEWSLETTER_SUCCESS, settings: payload });
    } catch (e) {
      commit('PUSH_MODAL', MODAL_LIST_DATA.NEWSLETTER_FAILURE);
      console.error('CUSTOM_ERROR: signUp modal error ' + e);
    }
  }
};
